<template>
  <div>

    <section id="content">
      <div class="content-wrap">
        <div class="container clearfix">
          <div class="row">
            <div class="col-sm-12" id="app">
              <div>
                <div class v-show="!carregando">
                  <div class="table-responsive" data-auto>
                    <div id="mensagem"></div>
                    <div id="errors" v-if="errors.length > 0">
                      <div class="style-msg2 errormsg">
                        <div class="msgtitle">Corrigir o(s) seguinte(s) erro(s):</div>
                        <div class="sb-msg">
                          <ul>
                            <li :key="index" v-for="(error,index) in errors">{{error}}</li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                  <vs-table :striped="true" search max-items="15" pagination :data="content">
                    <template slot="header" class="header-vstable">
                      <div class="area-header">
                        <h3>Regimes de contratação</h3>
                      </div>
                    </template>
                    <template slot="thead">
                      <vs-th style="width:45px;" class="text-center"></vs-th>
                      <vs-th style="text-align:center;"  class="text-center" :style="'width:'+iconArea+'px'">Ações</vs-th>
                      <vs-th sort-key="titulo">Título</vs-th>
                      <vs-th sort-key="tsInclusao" style="width:150px;" class="text-center">
                        <i class="icon-calendar"></i>
                      </vs-th>
                      <vs-th sort-key="ativo" style="width: 350px">Alterar item</vs-th>
                      <vs-th sort-key="ativoFixoId" style="width: 45px"
                        >Gravar</vs-th>
                      <vs-th sort-key="regimeId" style="width:45px;">ID</vs-th>
                    </template>
                    <template slot-scope="{data}">
                      <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td :data="indextr"  class="text-center" >{{indextr + 1}}</vs-td>
                        <vs-td  class="text-center acoes">
                          <a
                            class="icone-editar"
                            data-editar
                            @click="fnEdita('/paineldegerenciamento/listaregimescontratacao/'+data[indextr].regimeId+'/editar?aprovacao=s')"
                          >
                            <i class="i-circled i-small i-light icon-line-edit"></i>
                          </a>
                        </vs-td>
                        <vs-td :data="data[indextr].titulo">{{data[indextr].titulo}}</vs-td>
                        <vs-td  class="text-center" :data="data[indextr].tsInclusao">{{formatData(data[indextr].tsInclusao)}}</vs-td>
                        <vs-td
                          :data="data[indextr].ativo"
                          class="text-center text-icon"
                        >
                          <select
                            class="form-control"
                            id="_form-porte"
                            required
                            v-model="itemSelecionado"
                          >
                            <option value="" selected></option>
                            <option
                              :key="i"
                              v-for="(item, i) in contentLista"
                              :value="item.regimeId"
                            >
                              {{ item.titulo }}
                            </option>
                          </select>
                        </vs-td>
                        <vs-td :data="data[indextr].regimeId">
                          <button @click="fnAprova(data[indextr].regimeId)" class="btn btn-success">Gravar</button>
                        </vs-td>
                        <vs-td :data="data[indextr].regimeId">{{data[indextr].regimeId}}</vs-td>
                      </vs-tr>
                    </template>
                  </vs-table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- #content end -->
  </div>
</template>

<script>
import { deleteData, getData, getSuccess } from "../../../global/utils";

export default {
  
  data: function () {
    return {
      stripe: true,
      colorAlert: "primary",
      titleAlert: '',
      activeAlert: false,
      itemSelecionado:null,
      content: [],
      contentLista: [],
      iconArea: 50 * 1,
      errors: [],
      erro: "",
      urlApi: "listaregimescontratacao/clientes",
      carregando: true,
      deleteId: "",
      deleteAtivo: null,
      deleteTitulo: "",
    };
  },
  mounted() {
    this.fnCarregaItems();
  },
  methods: {
    async fnCarregaItems() {
      let data = await getData(this.urlApi);
      let dataLista = await getData(this.urlApi+"lista");
      this.content = data[0].content;
      this.contentLista = dataLista[0].content;
      this.carregando = false;
      this.$vs.loading.close();
    },
    async fnAprova(id){
        
        var completa = this.itemSelecionado != null?  "?idAlterado=" + this.itemSelecionado  :'';
        await this.$http.post("/listaregimescontratacao/altera/" + id + completa)
        .then(() =>{
            getSuccess();
            this.fnLimpa();
            this.fnCancela();
        })
       .catch(e => {
        return  e
        }); 
     this.fnCarregaItems();
    },
    fnAdd() {
      this.$router.push({path: "/paineldegerenciamento/listaregimescontratacao/novo"})
    },
    formatData(value) {
      return this.$moment(String(value)).format("DD/MM/YYYY HH:MM");
    },
    fnAtiva(valueId, valueTitle, valueAtivo) {
      this.deleteId = valueId;
      this.deleteTitulo = valueTitle;
      this.deleteAtivo = valueAtivo
      this.$vs.dialog({
        color: this.colorAlert,
        acceptText: 'Continuar',
        title: this.deleteAtivo ? "Deseja inativar o item " + valueTitle + "?" : "Deseja ativar o item "  + valueTitle + "?",
        text: this.deleteAtivo ? "O item não será exibido em algumas aplicações" : "O item será exibido normalmente nas aplicações",
        accept: this.fn_delete,
      });
    },
    async fn_delete() {
      await deleteData(this.urlApi+"ativa/", this.deleteId, "regimeId" ,this.deleteAtivo );
      this.fnCarregaItems();
      this.deleteAtivo = null
    },
    fnEdita(valueUrl){
        this.$router.push({path: valueUrl})
    }
  },

};
</script>

<style lang="less" scoped>
#page-menu-wrap {
  position: relative !important;
}
.vs-table-text {
  text-align: center;
}

.text-icon {
  span {
    display: block !important;
    text-align: center !important;
  }
  .i-small-xs {
    font-size: 10px !important;
    margin: 0 !important;
    height: 16px !important;
    width: 16px !important;
    line-height: 16px !important;
    float: none !important;
  }
}
.header-table {
  padding: 15px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: space-between !important;
}

</style>